import { fetchMe, type PublicUser } from "./api.js";
import { meQueryKey, queryClient, SESSION_STALE_MS } from "./query-client.js";

/**
 * The signed-in user, read through the query cache.
 *
 * The router re-runs `beforeLoad` on every navigation and does not cache its
 * result, so calling `fetchMe` there directly put one uncached round trip in
 * front of every filter click. Measured 2026-08-29 against production: eight
 * keystrokes in a filter box produced eight `/api/auth/me` requests that
 * finished 239ms, 439ms, 640ms, 844ms, 1050ms, 1256ms, 1480ms, 1678ms apart —
 * they serialise, because with no `Cache-Control` Chrome allows one request
 * per cache key in flight. The feed did not update for 2.1 seconds.
 *
 * Going through the cache makes every navigation after the first one free
 * until the session goes stale.
 */
export function loadSession(): Promise<PublicUser | null> {
  return queryClient.ensureQueryData({
    queryKey: meQueryKey,
    queryFn: fetchMe,
    staleTime: SESSION_STALE_MS,
  });
}

/**
 * Forget the cached session.
 *
 * Signing in has to call this: the guard cached the `null` that sent the
 * visitor to the login form, and without dropping it the post-login redirect
 * bounces straight back. Signing out reloads the page, which clears the whole
 * cache, so it does not need this.
 */
export function forgetSession(): void {
  queryClient.removeQueries({ queryKey: meQueryKey });
}
